import React from "react";
import "./test.css";

export default function TestimonialSection() {
  const testimonials = [
    {
      name: "Ravi",
      role: "Farmer from Maharashtra",
      text: "Agastya products helped me control pests effectively and boosted my crop yield. I've been a loyal customer for 5 years!",
      image: 'https://randomuser.me/api/portraits/men/32.jpg',
    },
    {
      name: "Suresh",
      role: "Farmer from Rajasthan",
      text: "I saw a clear improvement in yield after switching to Agastya's inputs. Their quality is consistent and pricing is fair. Highly recommended.",
      image: 'https://randomuser.me/api/portraits/men/45.jpg',
    },
    {
      name: "Suresh Patel",
      role: "Farmer from Maharashtra",
      text: "Agastya products helped me control pests effectively and boosted my crop yield. I've been a loyal customer for 5 years!",
      image: 'https://randomuser.me/api/portraits/men/67.jpg',
    },
    {
      name: "Ram",
      role: "Farmer from Maharashtra",
      text: "Agastya products helped me control pests effectively and boosted my crop yield. I've been a loyal customer for 5 years!",
      image: 'https://randomuser.me/api/portraits/men/78.jpg',
    },
    {
      name: "Amit",
      role: "Farmer from Rajasthan",
      text: "I saw a clear improvement in yield after switching to Agastya's inputs. Their quality is consistent and pricing is fair. Highly recommended.",
      image: 'https://randomuser.me/api/portraits/men/91.jpg',
    },
    {
      name: "Rajesh",
      role: "Farmer from Maharashtra",
      text: "Agastya products helped me control pests effectively and boosted my crop yield. I've been a loyal customer for 5 years!",
      image: 'https://randomuser.me/api/portraits/men/22.jpg',
    },
    {
      name: "Vijay",
      role: "Farmer from Maharashtra",
      text: "Agastya products helped me control pests effectively and boosted my crop yield. I've been a loyal customer for 5 years!",
      image: 'https://randomuser.me/api/portraits/men/56.jpg',
    },
  ];

  const Card = ({ t }) => (
    <div className="bg-white p-6 rounded-[22px] shadow-md min-w-[405px] max-w-[280px] shrink-0">
      <div className="flex items-center gap-4 mb-4">
        <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0 overflow-hidden">
          <img
            src={t.image}
            alt={`Portrait of ${t.name}`}
            className="w-full h-full object-cover"
            onError={(e) => { e.target.onerror = null; e.target.src = ''; e.target.style.display = 'none'; }}
          />
        </div>
        <div>
          <h3 className="text-gray-900 font-semibold text-[15px] leading-tight opacity-70">
            {t.name}
          </h3>
          <p className="text-sm text-gray-500 leading-tight opacity-70">
            {t.role}
          </p>
        </div>
      </div>
      <p className="text-gray-600 text-[15px] opacity-80">{t.text}</p>
    </div>
  );

  return (
    <section className="md:py-16 py-[60px] bg-gradient-to-b from-gray-50 to-[#F9F9FB] relative overflow-hidden">
      <div className="relative w-full max-w-[1272px] mx-auto ">

        {/** icon svg */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-10 h-10 flex items-center justify-center mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="62" viewBox="0 0 22 62" fill="none">
            <line x1="11.0248" y1="20.8184" x2="11.0248" y2="61.8182" stroke="#1C1C1C" strokeWidth="1.2"/>
            <rect x="0.808672" y="0.42" width="20.3827" height="13.0602" rx="4.38" stroke="#1C1C1C" strokeWidth="0.84"/>
            <path d="M8.27764 10.5424C7.78069 10.5424 7.35741 10.4072 7.00779 10.1367C6.65817 9.86408 6.39101 9.46938 6.20631 8.95265C6.0216 8.43372 5.92925 7.80704 5.92925 7.07262C5.92925 6.3426 6.0216 5.71922 6.20631 5.20248C6.39321 4.68355 6.66147 4.28776 7.01109 4.0151C7.36291 3.74024 7.78509 3.60281 8.27764 3.60281C8.77018 3.60281 9.19126 3.74024 9.54088 4.0151C9.8927 4.28776 10.161 4.68355 10.3457 5.20248C10.5326 5.71922 10.626 6.3426 10.626 7.07262C10.626 7.80704 10.5337 8.43372 10.349 8.95265C10.1643 9.46938 9.8971 9.86408 9.54748 10.1367C9.19786 10.4072 8.77458 10.5424 8.27764 10.5424ZM8.27764 9.8168C8.77018 9.8168 9.15278 9.57932 9.42544 9.10437C9.6981 8.62941 9.83443 7.95216 9.83443 7.07262C9.83443 6.48772 9.77176 5.98968 9.64643 5.57849C9.52329 5.1673 9.34518 4.85396 9.11211 4.63848C8.88122 4.42299 8.60307 4.31524 8.27764 4.31524C7.78949 4.31524 7.40799 4.55602 7.13313 5.03757C6.85827 5.51692 6.72084 6.19527 6.72084 7.07262C6.72084 7.65752 6.78241 8.15446 6.90555 8.56345C7.02868 8.97244 7.20569 9.28358 7.43657 9.49687C7.66965 9.71016 7.95001 9.8168 8.27764 9.8168ZM13.7644 10.5424C13.3115 10.5424 12.9113 10.4622 12.5638 10.3016C12.2186 10.1389 11.9493 9.91575 11.7558 9.6321C11.5623 9.34624 11.4666 9.02081 11.4688 8.6558C11.4666 8.36995 11.5227 8.10608 11.637 7.86421C11.7514 7.62014 11.9075 7.41674 12.1054 7.25402C12.3055 7.08911 12.5287 6.98466 12.7749 6.94069V6.90111C12.4517 6.81755 12.1944 6.63614 12.0031 6.35689C11.8118 6.07543 11.7173 5.7555 11.7195 5.39708C11.7173 5.05406 11.8041 4.74732 11.98 4.47686C12.1559 4.2064 12.3978 3.99311 12.7057 3.83699C13.0157 3.68087 13.3686 3.60281 13.7644 3.60281C14.1558 3.60281 14.5054 3.68087 14.8133 3.83699C15.1211 3.99311 15.363 4.2064 15.5389 4.47686C15.717 4.74732 15.8072 5.05406 15.8094 5.39708C15.8072 5.7555 15.7093 6.07543 15.5158 6.35689C15.3245 6.63614 15.0705 6.81755 14.7539 6.90111V6.94069C14.998 6.98466 15.2179 7.08911 15.4136 7.25402C15.6093 7.41674 15.7654 7.62014 15.8819 7.86421C15.9985 8.10608 16.0578 8.36995 16.06 8.6558C16.0578 9.02081 15.9589 9.34624 15.7632 9.6321C15.5697 9.91575 15.3003 10.1389 14.9551 10.3016C14.6121 10.4622 14.2152 10.5424 13.7644 10.5424ZM13.7644 9.8168C14.0701 9.8168 14.3339 9.76733 14.556 9.66838C14.7781 9.56943 14.9496 9.4298 15.0705 9.24949C15.1915 9.06919 15.253 8.8581 15.2552 8.61622C15.253 8.36115 15.1871 8.13577 15.0573 7.94007C14.9276 7.74437 14.7506 7.59045 14.5263 7.47831C14.3042 7.36617 14.0503 7.3101 13.7644 7.3101C13.4764 7.3101 13.2191 7.36617 12.9926 7.47831C12.7683 7.59045 12.5913 7.74437 12.4616 7.94007C12.3341 8.13577 12.2714 8.36115 12.2736 8.61622C12.2714 8.8581 12.3297 9.06919 12.4484 9.24949C12.5693 9.4298 12.7419 9.56943 12.9662 9.66838C13.1905 9.76733 13.4566 9.8168 13.7644 9.8168ZM13.7644 6.61086C14.0063 6.61086 14.2207 6.56248 14.4076 6.46573C14.5967 6.36898 14.7451 6.23375 14.8529 6.06004C14.9606 5.88633 15.0156 5.68294 15.0178 5.44986C15.0156 5.22118 14.9617 5.02218 14.8562 4.85287C14.7506 4.68135 14.6044 4.54942 14.4175 4.45707C14.2306 4.36252 14.0129 4.31524 13.7644 4.31524C13.5115 4.31524 13.2906 4.36252 13.1015 4.45707C12.9124 4.54942 12.7661 4.68135 12.6628 4.85287C12.5594 5.02218 12.5089 5.22118 12.5111 5.44986C12.5089 5.68294 12.5605 5.88633 12.6661 6.06004C12.7738 6.23375 12.9223 6.36898 13.1114 6.46573C13.3005 6.56248 13.5181 6.61086 13.7644 6.61086Z" fill="#1C1C1C"/>
          </svg>
          </div>
        </div>

        {/* Heading */}
        <div className="text-center w-full max-w-[551px] mx-auto mb-12 px-4">
          <h2 className="text-[28px] md:text-[44px] font-[LTWave] font-bold mb-4 whitespace-nowrap">
            Real Stories Real Impact.
          </h2>
          <p className="text-gray-700">
            Hear directly from the farmers who've experienced the difference
            Agastya Agro makes in their fields, yields, and lives.
          </p>
        </div>

        {/* Desktop View - 3 Columns */}
        <div className="hidden md:block relative">
          <div className="carousel_container">
            <div className="carousel_col scroll-up">
              {[...testimonials, ...testimonials].map((t, i) => (
                <Card key={`left-${i}`} t={t} />
              ))}
            </div>

            <div className="carousel_col scroll-down">
              {[...testimonials, ...testimonials].map((t, i) => (
                <Card key={`middle-${i}`} t={t} />
              ))}
            </div>

            <div className="carousel_col scroll-up">
              {[...testimonials, ...testimonials].map((t, i) => (
                <Card key={`right-${i}`} t={t} />
              ))}
            </div>
          </div>

          {/* Fade Shadows */}
          <div className="absolute top-0 left-0 w-full h-16 bg-gradient-to-b from-[#F9F9FB] to-transparent pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-full h-16 bg-gradient-to-t from-[#F9F9FB] to-transparent pointer-events-none"></div>
        </div>

        {/* Mobile View - 3 Horizontal Rows */}
        <div className="md:hidden relative flex flex-col gap-6 overflow-hidden">
          {/* Row 1 - scroll left */}
          <div className="flex gap-4 animate-scroll-x">
            {[...testimonials, ...testimonials].map((t, i) => (
              <Card key={`row1-${i}`} t={t} />
            ))}
          </div>
          {/* Row 2 - scroll right */}
          <div className="flex gap-4 animate-scroll-x-reverse">
            {[...testimonials, ...testimonials].map((t, i) => (
              <Card key={`row2-${i}`} t={t} />
            ))}
          </div>
          {/* Row 3 - scroll left */}
          <div className="flex gap-4 animate-scroll-x">
            {[...testimonials, ...testimonials].map((t, i) => (
              <Card key={`row3-${i}`} t={t} />
            ))}
          </div>

          {/* Fade Shadows */}
          <div className="md:block hidden absolute top-0 left-0 w-16 h-full bg-gradient-to-r from-[#F9F9FB] to-transparent pointer-events-none"></div>
          <div className="md:block hidden absolute top-0 right-0 w-16 h-full bg-gradient-to-l from-[#F9F9FB] to-transparent pointer-events-none"></div>
        </div>
      </div>
    </section>
  );
}
